const STORAGE_KEY = 'derelict-player-name';

export function getStoredPlayerName(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setStoredPlayerName(name: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, name);
  } catch {
    // Ignore storage errors
  }
}
